var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"caption grey--text",class:{ 'caption--combobox': _vm.forCombobox }},[_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(this.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }